import * as actionTypes from '../actions/actionTypes';

const initialState = {
    error: null,
    loginInProgress: false,
    isAuthenticated: false,
    userId: null,
    token: localStorage.getItem('token'),
    twofa: false,
    twofaMethod:null,
    authRedirect: '/home',
    verified: false,
    caseId: null,
    typeOfAccount: null,
    newAccount: true,
    recoverPassword: null,
    changePassword: null,
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.AUTH_START:
            return {
                ...state,
                error: null,
                loginInProgress: true,
            };
        case actionTypes.UPDATE_VERIFY_2_CODE_TO_TRUE_ACTION:
            return {
                ...state,
                twofa: true,
            };
        case actionTypes.AUTH_SUCCESS:
        console.log('AUTH_SUCCESS reducer: '+JSON.stringify(action))
            return {
                ...state,
                error: null,
                isAuthenticated: true,
                loginInProgress: false,
                twofa: false,
                twofaMethod: action.twofaMethod,
                userId: action.userId,
                token: action.token,
                typeOfAccount: action.typeOfAccount,
                caseId: action.caseId,
                verified: action.verified
            };
        case actionTypes.AUTH_FAIL:
            return {
                ...state,
                error: action.error,
                isAuthenticated: false,
                loginInProgress: false,

            };
        case actionTypes.AUTH_LOGOUT:
        return {
            ...state,
            error: null,
            loginInProgress: false,
            isAuthenticated: false,
            twofa: false,
            twofaMethod: null,
            userId: null,
            token: null,
            caseId: null,
            verified: null,
        };
        case actionTypes.SET_AUTH_REDIRECT_PATH:
        return {
            ...state,
            authRedirect: action.path,
        };
        case actionTypes.AUTH_SUCCESS_ON_TRY_LOGIN:
        return {
            ...state,
            isAuthenticated: true,
        };
        case actionTypes.RECOVER_PASSWORD_SUCCESS:
        return{
            ...state,
            recoverPassword:true,
        };
        case actionTypes.RECOVER_PASSWORD_FAIL:
        return{
            ...state,
            recoverPassword:false,
        };
        case actionTypes.CHANGE_PASSWORD_SUCCESS:
        return{
            ...state,
            changePassword:true,
        };
        case actionTypes.CHANGE_PASSWORD_FAIL:
        return{
            ...state,
            changePassword:false,
        };
        default:
            return state;
    }

};

export default authReducer;